/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type Notifications_initialViewer = {
    readonly " $fragmentRefs": FragmentRefs<"Conversations_viewer" | "NotificationsIcon_viewer">;
    readonly " $refType": "Notifications_initialViewer";
};
export type Notifications_initialViewer$data = Notifications_initialViewer;
export type Notifications_initialViewer$key = {
    readonly " $data"?: Notifications_initialViewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"Notifications_initialViewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isClient"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "Notifications_initialViewer",
    "selections": [
        {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "Defer",
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "Conversations_viewer"
                        }
                    ]
                },
                {
                    "kind": "Defer",
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "NotificationsIcon_viewer"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = 'c6cb02d8a70fd78b905c9e772b728f8d';
export default node;
